import axios from '@/libs/api.request';

export const getMemberTransaction = data => {
    return axios.request({
        url: 'api/financeManagement/memberTransaction/getMemberTransaction',
        data: data,
        method: 'post'
    });
};

export const getMemberTransactionSum = data => {
    return axios.request({
        url: 'api/financeManagement/memberTransaction/getMemberTransactionSum',
        data: data,
        method: 'post'
    });
};

export const getMemberTransactionSumSql = data => {
    return axios.request({
        url: 'api/financeManagement/memberTransaction/getMemberTransactionSumSql',
        data: data,
        method: 'post'
    });
};


export const QueryABCTransaction = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/ABCPay/QueryABCTransaction',
        data: data,
        method: 'post'
    });
};

export const notifyABCPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/ABCPay/notifyABCPay',
        data: data,
        method: 'post'
    });
};

export const getDayTransactionSum = data => {
    return axios.request({
        url: 'api/financeManagement/memberTransaction/getDayTransactionSum',
        data: data,
        method: 'post'
    });
};


